import { TextField } from '@material-ui/core';

export default class extends React.PureComponent {
	render() {
		return <TextField {...this.props} autoComplete="off" />
	}
}